<template>
  <main class="home">
    <JroHeaderNew />
    <JroLinksNew />
    <JroProjectsNew />
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import JroHeaderNew from "@/components/JroHeaderNew.vue";
import JroLinksNew from "@/components/JroLinksNew.vue";
import JroProjectsNew from "@/components/JroProjectsNew.vue";

export default defineComponent({
  name: "JroHome",
  components: {
    JroHeaderNew,
    JroLinksNew,
    JroProjectsNew,
  },
});
</script>

<style scoped>
.home {
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
}
</style>
